import React, { useState, useEffect } from 'react'
import { DocumentIcon, EquisIcons } from '../utils/icons';
import { connect } from 'react-redux'
import './SummaryBudgetPage.scss'
import Separator from '../components/Separator';
import SummaryProductBudget from '../components/SummaryProductBudget';
import { NavLink } from 'react-router-dom';
import * as _ from 'lodash'
import { scrollBodyTop } from '../hooks/scrollPosition';
import { NotFoundIcon } from '../utils/icons'
import { privilegeUser, tokerUser } from '../hooks/user';
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import { resetBudget, showPopup, showSpinner } from '../actions'
import { comprobarDatos } from '../hooks/validateForm';
import { PopupOneButton } from '../components/PopupOneButton';
import { useNavigate } from 'react-router-dom';
import { saveBudget } from '../hooks/budget';
import { DobleGuion } from '../components/DobleGuion';
import BrandChosenBanner from './BrandChosenBanner';

const SummaryBudgetPage = (props) => {
    const navigate = useNavigate();
    const { userActive } = props
    const [privilege, setPrivilege] = useState(undefined)
    const [productsBudget, setProductsBudget] = useState(props.budget)
    const [cartSave, setCartSave] = useState(false)
    const [totalPrice, setTotalPrice] = useState(undefined)
    const [addLocationCart, setAddLocationCart] = useState(false)
    const [location, setLocation] = useState('')
    const [userBudget, setUserBudget] = useState({
        cif: '',
        empresa: '',
        name: '',
        email: '',
        role: '',
        phonenumber: '',
        zone: ''
    })

    const reglas = {
        cif: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        empresa: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        name: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
        phonenumber: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            format: { pattern: '[0-9]+', message: 'solo puede contener digitos del 0 al 9' },
        },
        email: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
            email: { message: 'con un formato invalido' },
        },
        zone: {
            presence: { allowEmpty: false, message: 'es un campo obligatorio' },
        },
    };

    useEffect(() => {
        scrollBodyTop()
        getPrivilege()
    }, [])

    useEffect(() => {
        setProductsBudget(props.budget)
        getPrivilege()
    }, [props.budget])

    useEffect(() => {
        getPrivilege()
        if (!_.isEmpty(userActive)) {
            setUserBudget({
                cif: userActive.cif,
                empresa: userActive.empresa,
                name: userActive.name,
                email: userActive.email,
                role: userActive.role,
                phonenumber: userActive.phonenumber,
                zone: userActive.zone
            })
        } else {
            setUserBudget({
                cif: '',
                empresa: '',
                name: '',
                email: '',
                role: '',
                phonenumber: '',
                zone: ''
            })

        }
    }, [userActive])

    useEffect(() => {
        const interval = setInterval(() => {
            if (props.budget.length > 0) {
                autoSaveBudget();
            }
        }, 240000); // 60,000 ms = 60 segundos
    
        return () => clearInterval(interval);
    }, [props.budget, userBudget, location]);
    
    const autoSaveBudget = async () => {
        try {
            const tokenUser = await tokerUser();
            const data = {
                tokenUser,
                userBudget,
                budget: props.budget,
                location
            };
            await saveBudget(data);
            console.log("Presupuesto guardado automáticamente");
        } catch (err) {
            console.warn("Error en autoguardado:", err);
        }
    };
    
    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    const changeProduct = () => {
        let totalTemp = 0
        for (let i = 0; i < props.budget.length; i++) {
            const product = props.budget[i];
            const priceUnitString = product.product.PrecioTarifa.replace(',', '.')
            const priceUnitNumber = parseFloat(priceUnitString)
            const price = product.total * priceUnitNumber
            totalTemp += price
        }
        const totalString = totalTemp.toFixed(2)
        const total = totalString.replace('.', ',')
        setTotalPrice(total)
    }

    const handleClickSend = () => {
        const alias = {
            name: 'nombre',
            phonenumber: 'teléfono',
            zone: 'zona'
        }
        comprobarDatos(userBudget, reglas, alias).then(res => {
            props.showSpinner(true)
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useActiveDesactiveSrollBody(true)
            tokerUser().then(res => {
                const tokenUser = res
                const data = {
                    tokenUser: tokenUser,
                    userBudget: userBudget,
                    budget: props.budget,
                    location: location
                }
                saveBudget(data).then(res => {
                    setCartSave(true)
                    setAddLocationCart(false)
                    props.showSpinner(false)
                    props.resetBudget()
                }).catch(err => {
                  console.log('err', err);
                    props.showSpinner(false)
                    setAddLocationCart(false)
                    props.showPopup({ active: true, message: 'Error al guardar el presupuesto', type: 'error' })
                })
            })
        }).catch(err => {
            props.showSpinner(false)
            props.showPopup({ active: true, message: err, type: 'error' })
        })
    }

    const handleSetLocation = (event) => {
        setLocation(event.target.value)
    }

    const handleClickEnd = () => {
        setCartSave(false)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(false)
        navigate('/');
    }

    return (
        <div className="summary-budget-page-container">
            {addLocationCart &&
                <div className="location-input-container">
                    <div className="location-content">
                        <div className="title">
                            <div className="text">
                                <p>Centro / localidad</p>
                                <DobleGuion />
                            </div>
                            <div className="botones">
                                <button className="pointer" onClick={() => setAddLocationCart(false)}><EquisIcons size={15} /></button>
                            </div>
                        </div>
                        <div className="input-block">
                            <div className="input">
                                <input type="text" name="location" value={location} onChange={handleSetLocation} />
                            </div>
                        </div>
                        <div className="boton">
                            <button className="btn" onClick={handleClickSend}>GUARDAR</button>
                        </div>
                    </div>
                </div>
            }
            {cartSave &&
                <PopupOneButton title="¡Presupuesto guardado!" text="Puedes continuar con su solicitud, enviando de nuevos los productos a la lista desde el área de presupuesto guardados." textButton="Aceptar" onClick={handleClickEnd} />
            }
            <div className="brand-chosen-banner">
              <BrandChosenBanner />
            </div>
            <div className="header">
                <div className="text">
                    <p>Resumen de presupuesto</p>
                    {totalPrice !== undefined && privilege &&
                        <p className="price">Total bruto: {totalPrice}€</p>
                    }
                </div>
                <DocumentIcon size={40} />
            </div>
            <div className="separator">
                <Separator />
            </div>
            {productsBudget.length > 0 ?
                <React.Fragment>
                    <div className="products">
                        {
                            productsBudget.map((product, index) => {
                                return (
                                    <div key={index}>
                                        <SummaryProductBudget productBudget={product} changeProduct={changeProduct} />
                                        <Separator />
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="boton">
                        <button className="btn" onClick={() => setAddLocationCart(true)}>GUARDAR</button>
                        <NavLink activeClassName="active" to="/formulario"><button className="btn">SIGUIENTE</button></NavLink>
                    </div>
                </React.Fragment>
                :
                <div className="sin-productos">
                    <div className="icon">
                        <NotFoundIcon size={70} />
                    </div>
                    <div className="text">
                        <p>Presupuesto vacio</p>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    resetBudget,
    showPopup,
    showSpinner
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryBudgetPage)
